import React from 'react';
import { NavLink } from 'react-router-dom';
import { ROLE_LABELS } from '../utils/auth';
import { useI18n, useT } from '../i18n/I18nContext';

export default function Sidebar({ user, onLogout, open, onClose }) {
  const { lang, setLang } = useI18n();
  const t = useT();

  const isAgent = user?.role === 'agent';

  const navItems = isAgent ? [
    { to:'/agent-portal', icon:'📋', label:'Minhas Cotações' },
    { to:'/agent-orders', icon:'📦', label:'Meus Pedidos'    },
  ] : [
    { to:'/',           icon:'📊', key:'nav.dashboard'  },
    { to:'/kanban',     icon:'🗂️', key:'nav.kanban'     },
    { to:'/quotations', icon:'📋', key:'nav.quotations' },
    { to:'/orders',     icon:'📦', key:'nav.orders'     },
    { to:'/consolidations', icon:'🔗', label:'Consolidações' },
    { to:'/containers', icon:'🚢', label:'Containers'   },
    { to:'/samples',    icon:'🧪', key:'nav.samples'    },
    { to:'/suppliers',  icon:'🏭', key:'nav.suppliers'  },
    { to:'/agents',     icon:'🧑‍💼', key:'nav.agents'    },
    { to:'/products',       icon:'📦', key:'nav.products'   },
    ...((['admin','buyer','analyst'].includes(user?.role)) ? [{ to:'/import-config', icon:'🧾', key:'nav.import' }] : []),
    { to:'/reports',        icon:'📈', key:'nav.reports'    },
    ...(user?.role === 'admin' ? [{ to:'/users', icon:'👥', key:'nav.users' }] : []),
  ];

  return (
    <aside className={`sidebar${open ? ' sidebar--open' : ''}`}>
      <div className="sidebar-logo">
        <img src="/logo-charth.png" alt="Charth" />
        <span>Sourcing System</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            onClick={onClose}
          >
            <span className="nav-icon">{item.icon}</span>
            {item.label || t(item.key)}
          </NavLink>
        ))}
      </nav>

      {/* Usuário + logout */}
      <div style={{ padding:'14px 18px', borderTop:'1px solid rgba(255,255,255,.1)', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
          <div style={{
            width:32, height:32, borderRadius:'50%',
            background:'rgba(255,255,255,.15)',
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:14, fontWeight:700, color:'white', flexShrink:0,
          }}>
            {user?.name?.[0]?.toUpperCase() || '?'}
          </div>
          <div style={{ overflow:'hidden' }}>
            <div style={{ fontSize:12.5, fontWeight:600, color:'white', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {user?.name}
            </div>
            <div style={{ fontSize:10.5, color:'rgba(255,255,255,.5)' }}>
              {ROLE_LABELS[user?.role] || user?.role}
            </div>
          </div>
        </div>

        {/* Botão PT/EN */}
        <button
          onClick={() => setLang(lang === 'pt' ? 'en' : 'pt')}
          style={{
            width:'100%', background:'rgba(255,255,255,.05)',
            border:'1px solid rgba(255,255,255,.12)',
            borderRadius:'var(--radius)', padding:'5px',
            color:'rgba(255,255,255,.5)', fontSize:11,
            cursor:'pointer', marginBottom:6, fontFamily:'var(--font)',
          }}
        >
          {lang === 'pt' ? '🇺🇸 English' : '🇧🇷 Português'}
        </button>

        <button
          onClick={onLogout}
          style={{
            width:'100%', background:'rgba(255,255,255,.08)',
            border:'1px solid rgba(255,255,255,.12)',
            borderRadius:'var(--radius)', padding:'7px',
            color:'rgba(255,255,255,.6)', fontSize:12,
            cursor:'pointer', transition:'all .15s', fontFamily:'var(--font)',
          }}
          onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,.14)'}
          onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,.08)'}
        >
          {t('nav.logout')}
        </button>
        <div style={{ marginTop:8, fontSize:10, color:'rgba(255,255,255,.25)', textAlign:'center' }}>
          v3.0 · Charth © 2026
        </div>
      </div>
    </aside>
  );
}
